import merge from "deepmerge";
import { green, grey } from "@mui/material/colors";
import { THEMES } from "core/constants/theme";

export const customOrange = {
  50: "#fff8e9",
  100: "#ffe8bc",
  200: "#ffdd9b",
  300: "#ffcd6e",
  400: "#ffc451",
  500: "#ffb526",
  600: "#e8a523",
  700: "#b5811b",
  800: "#8c6415",
  900: "#6b4c10",
  1000:"#FF5B06"
};

const defaultVariant = {
  name: THEMES.DEFAULT,
  palette: {
    mode: "light",
    primary: {
      main: customOrange[1000],
      contrastText: "#FFF",
    },
    secondary: {
      main: customOrange[500],
      contrastText: "#FFF",
    },
    info: {
      main: "#000",
    },
    background: {
      default: "#E8EAEE",
      paper: "#FFF",
    },
    success: {
      main: "#99F279",
    },
    error: {
      main: "#F26188",
    },
    warning: {
      main: "#F2CB61",
    },
  },
  header: {
    color: grey[500],
    background: "#E8EAEE",
    search: {
      color: grey[800],
    },
    indicator: {
      background: customOrange[600],
    },
  },
  footer: {
    color: grey[500],
    background: "#FFF",
  },
  sidebar: {
    color: grey[200],
    background: "#1B2430",
    header: {
      color: grey[200],
      background: "#232F3E",
      brand: {
        color: customOrange[500],
      },
    },
    footer: {
      color: grey[200],
      background: "#232F3E",
      online: {
        background: green[500],
      },
    },
    badge: {
      color: "#FFF",
      background: customOrange[500],
    },
  },
};

const variants: Array<VariantType> = [defaultVariant];

export default variants;

export type VariantType = {
  name: string;
  palette: {
    primary: MainContrastTextType;
    secondary: MainContrastTextType;
  };
  header: ColorBgType & {
    search: {
      color: string;
    };
    indicator: {
      background: string;
    };
  };
  footer: ColorBgType;
  sidebar: ColorBgType & {
    header: ColorBgType & {
      brand: {
        color: string;
      };
    };
    footer: ColorBgType & {
      online: {
        background: string;
      };
    };
    badge: ColorBgType;
  };
};

type MainContrastTextType = {
  main: string;
  contrastText: string;
};
type ColorBgType = {
  color: string;
  background: string;
};
